"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessoryItem = void 0;
var accessory_item_1 = require("./accessory-item");
Object.defineProperty(exports, "AccessoryItem", { enumerable: true, get: function () { return __importDefault(accessory_item_1).default; } });
//# sourceMappingURL=index.js.map